import * as React from "react";
import { format, formatISO } from "date-fns";
import { useLocation } from "react-router-dom";

import { useQuery } from "@apollo/client";
import {
  GET_PANUI,
  getPanuiSlug,
  PageData,
  PageTitle,
  PanuiQueryData,
  showLoad,
} from "@plinknz/tah-website-elements";

import { Page, PAGE_SUFFIX } from "./page";
import { Content } from "../components/content-blocks/content";
import { Hero } from "../components/hero";
import { Loader } from "../components/loader";
import { Menu } from "../components/menu";

export const Panui = () => {
  const location = useLocation();
  const slug = getPanuiSlug(location);
  const { loading, data, error } = useQuery<PanuiQueryData>(GET_PANUI, {
    variables: {
      sort: "published_date:desc",
      filters: { slug: { eq: slug } },
      pagination: { limit: -1 },
    },
  });

  if (!data && showLoad(loading)) {
    return (
      <div className="splash">
        <Loader size="large" />
      </div>
    );
  }

  if (!showLoad(loading) && !error && data?.newsItems.length === 0) {
    // Redirect 404s in case there is a page with a pānui prefix
    return <Page />;
  }

  if (error) {
    console.warn(error);
    const errorMessage = error?.graphQLErrors
      .map((graphqlError) =>
        graphqlError.extensions?.exception
          ? // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-member-access
            `${graphqlError.extensions.exception.output.statusCode} ${graphqlError.extensions.exception.message}`
          : null
      )
      .filter(Boolean)
      .join(", ");

    return (
      <Hero title="There was an unexpected error" subtitle={errorMessage} />
    );
  }

  const page = data?.newsItems?.[0];

  if (!page) {
    // Redirect 404s in case there is a page with a pānui prefix
    return <Page />;
  }

  const datePublished = page.published_at ? new Date(page.published_at) : null;

  return (
    <>
      <Hero
        title={page.headline}
        images={page.cover_image}
        subtitle={
          <>
            {page.author && <> {page.author} &bull; </>}
            {datePublished && (
              <time dateTime={formatISO(datePublished)}>
                {format(datePublished, "dd MMMM, yyyy")}
              </time>
            )}
          </>
        }
      />
      <PageTitle title={page.headline} suffix={PAGE_SUFFIX} />
      <Menu
        links={[]}
        parent={{
          slug: "/panui",
          title: "Pānui",
          parent: null,
        }}
        currentPage={({ title: page.headline } as unknown) as PageData}
        show={false}
        panuiDate={page.published_at}
      />
      <article className="page">
        <Content
          data={{
            __typename: "ComponentContentBlocksContent",
            id: page.documentId,
            content: page.content,
          }}
        />
      </article>
    </>
  );
};
